import React, { useState } from "react";
import styles from "./NewConsultation.module.css";

const NewConsultation = ({ onComplete }) => {
  const [publishingType, setPublishingType] = useState("자비출판");
  const [content, setContent] = useState("");
  const [answerContent, setAnswerContent] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting new consultation:", {
      publishingType,
      content,
      answerContent,
    });
    alert("상담 신청이 완료되었습니다.");
    onComplete();
  };

  const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, ".");

  return (
    <div>
      <h2 className={styles.sectionTitle}></h2>

      <div className={styles.detailHeader}>
        <span className={styles.detailHeaderTitle}>
          [ {publishingType} ] 상담 신청
        </span>
        <span className={styles.detailHeaderDate}>{currentDate}</span>
      </div>

      <form onSubmit={handleSubmit} className={styles.consultationForm}>
        <div className={styles.fieldRow}>
          <label className={styles.fieldLabel}>이름</label>
          <div className={styles.fieldValueDisplay}>에이콘</div>
        </div>
        <div className={styles.fieldRow}>
          <label className={styles.fieldLabel}>이메일</label>
          <div className={styles.fieldValueDisplay}>
            acornpub@acornpub.co.kr
          </div>
        </div>
        <div className={styles.fieldRow}>
          <label className={styles.fieldLabel}>전화번호</label>
          <div className={styles.fieldValueDisplay}>010-1234-5678</div>
        </div>
        <div className={styles.fieldRow}>
          <label className={styles.fieldLabel}>출판유형</label>
          <select
            value={publishingType}
            onChange={(e) => setPublishingType(e.target.value)}
            className={styles.selectInput}
          >
            <option value="자비출판">자비출판</option>
            <option value="반기획출판">반기획출판</option>
            <option value="기획출판">기획출판</option>
            <option value="아마존 킨들 출판 대행">아마존 킨들 출판 대행</option>
          </select>
        </div>
        <div className={styles.fieldRow}>
          <label className={styles.fieldLabel}>상담내용</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className={styles.textareaInput}
            placeholder="상담 내용을 입력해 주세요"
            rows="10"
            required
          />
        </div>

        <h2 className={`${styles.sectionTitle} ${styles.answerTitle}`}>답변</h2>
        <div className={styles.textareaInputWrapper}>
          <textarea
            value={answerContent}
            onChange={(e) => setAnswerContent(e.target.value)}
            className={styles.textareaInput}
            placeholder="답변 내용을 입력해 주세요"
            rows="10"
          />
        </div>

        <div className={styles.formActions}>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onComplete}
          >
            목록으로
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewConsultation;
